import useJwt from "@/auth/jwt/useJwt";
const axios = useJwt.axiosIns;

export function getRole() {
  const role = useJwt.getRole();
  console.log({ role });
  return role;
}
